/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitButtonsButtonGroup.module.scss';

const ButtonGroup = ({
  children,
  className = '',
  isSpaced = true,
  orientation = 'horizontal',
  testId = '',
  variant = 'default',
  ...other
}) => {
  if (!React.Children.count(children)) return null;

  const CLASSES = {
    variant: {
      compact: styles.isVariantCompact,
      default: styles.isVariantDefault,
      outlined: styles.isVariantOutlined,
    },
  };

  return (
    <div
      className={classnames(
        styles.element,
        {
          [styles.isSpaced]: isSpaced,
          [styles.isVertical]: orientation === 'vertical',
          [CLASSES.variant[variant]]: variant,
        },
        className,
      )}
      role="group"
      data-testid={testId}
      {...other}
    >
      {children}
    </div>
  );
};

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isSpaced: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(['compact', 'default', 'outlined']),
};

export { ButtonGroup as ButtonGroupStorybook };
export default React.memo(ButtonGroup);
